module.exports = __webpack_public_path__ + "static/media/nope click.014e2744.gif";